import { clsx, type ClassValue } from 'clsx';
import { cn as portalCn } from '@bcecloud/portal-ui';

/**
 * Merges class names, resolving Tailwind conflicts. Present under this exact
 * path because shadcn-registry components (AI Elements) import `@/lib/utils`.
 *
 * Delegates the actual merge to portal-ui's `cn`, which teaches tailwind-merge
 * that `text-portal-<size>` and `text-portal-<color>` are DIFFERENT groups.
 * Plain `twMerge` treats both as `text-*` and drops the size — so combining a
 * portal size token with a portal colour token (e.g. `text-portal-small` +
 * `text-portal-ink`) silently fell back to the 16px browser default. clsx runs
 * first so object/array class values from shadcn components still flatten.
 *
 * @param inputs - Class values in precedence order.
 * @returns The merged class string.
 */
export function cn(...inputs: ClassValue[]): string {
  return portalCn(clsx(inputs));
}

/**
 * Classes for a refresh icon that spins while its action runs — the shared
 * "Sync" affordance on program and shipment detail pages.
 *
 * @param spinning - Whether the sync is in flight.
 * @returns The icon's class string.
 */
export function cnSpin(spinning: boolean): string {
  return spinning ? 'size-4 animate-spin' : 'size-4';
}
